import { render, staticRenderFns } from "./askData.vue?vue&type=template&id=39399745&scoped=true&"
import script from "./askData.vue?vue&type=script&lang=js&"
export * from "./askData.vue?vue&type=script&lang=js&"
import style0 from "./askData.vue?vue&type=style&index=0&id=39399745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39399745",
  null
  
)

export default component.exports